import { c as _c } from "react/compiler-runtime";
export const MoneyBagIcon = t0 => {
  const $ = _c(15);
  const {
    selected
  } = t0;
  const strokeColor = selected ? "#EFFCF8" : "#008254";
  const t1 = selected ? "#008254" : "#EFFCF8";
  let t2;
  if ($[0] !== t1) {
    t2 = <rect x="0.357178" width="40" height="40" rx="20" fill={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[2] !== strokeColor) {
    t3 = <path d="M18.2517 12.1053L20.357 10L22.4623 12.1053C22.881 12.1053 23.809 11.219 24.1051 11.5151C24.4012 11.8112 24.5675 12.2128 24.5675 12.6316C24.5675 13.6087 24.1794 14.5458 23.4885 15.2367C22.7975 15.9276 21.8604 16.3158 20.8833 16.3158H19.8307C18.8536 16.3158 17.9165 15.9276 17.2256 15.2367C16.5346 14.5458 16.1465 13.6087 16.1465 12.6316C16.1465 12.2128 16.3128 11.8112 16.6089 11.5151C16.9051 11.219 17.833 12.1053 18.2517 12.1053Z" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M11.936 25.7895V24.7368C11.936 22.5034 12.8233 20.3615 14.4025 18.7823C15.9818 17.203 18.1237 16.3158 20.3571 16.3158C22.5905 16.3158 24.7324 17.203 26.3117 18.7823C27.8909 20.3615 28.7781 22.5034 28.7781 24.7368V25.7895C28.7781 26.9062 28.3345 27.9771 27.5449 28.7668C26.7553 29.5564 25.6843 30 24.5676 30H16.1466C15.0299 30 13.9589 29.5564 13.1693 28.7668C12.3796 27.9771 11.936 26.9062 11.936 25.7895Z" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t5 = <path d="M20.3904 25.8891V26.6019V27.3148" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t6 = <path d="M20.3904 19.4737V20.1865V20.8993" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t7 = <path d="M22.1725 20.8994H19.4994C19.1686 20.8994 18.8513 21.0308 18.6173 21.2647C18.3834 21.4987 18.252 21.816 18.252 22.1468C18.252 22.4776 18.3834 22.7949 18.6173 23.0289C18.8513 23.2628 19.1686 23.3942 19.4994 23.3942H21.2815C21.6123 23.3942 21.9296 23.5257 22.1635 23.7596C22.3975 23.9936 22.5289 24.3108 22.5289 24.6417C22.5289 24.9725 22.3975 25.2898 22.1635 25.5238C21.9296 25.7577 21.6123 25.8891 21.2815 25.8891H18.252" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = strokeColor;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6 || $[13] !== t7) {
    t8 = <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">{t2}{t3}{t4}{t5}{t6}{t7}</svg>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};